export const makeChapterAnnotationKey = (_version, book, chapter) => (
  `all:${book}:${chapter}`
);

export const makeHighlightChapterKey = (version, book, chapter) => (
  `${version || 'ESV'}:${book}:${chapter}`
);
